export default class BookNowForm {
  constructor() {
    const $els = document.querySelectorAll('.js-book-now-form');
    $els.forEach($el => new Form($el));
  }
}

class Form {
  constructor($el) {
    this.$el = $el;
    this.$el.addEventListener('submit', this.onSubmit.bind(this));
  }

  onSubmit(e) {
    e.preventDefault();
      const email = this.$el.querySelector('.js-book-now-form-email').value;

      let path = `/book-a-demo/?email=${email}`;

      window.location = path;
  }
}
